import type { HTMLProps } from 'react'
import * as Dialog from '@radix-ui/react-dialog'
import * as Popover from '@radix-ui/react-popover'
import { Button } from '@sunwebgroup/uds-ui/button'
import cn from 'classnames'
import * as React from 'react'
import styles from './ConfirmButton.module.css'
import { DropdownMultiselectContext } from './context'

function ConfirmButton({ children, className }: HTMLProps<HTMLButtonElement>) {
  const { asDialog } = React.use(DropdownMultiselectContext)
  const content = <Button fullWidth>{children}</Button>
  return (
    <div className={cn(styles.wrapper, className)}>
      {asDialog && <Dialog.Close asChild>{content}</Dialog.Close>}
      {!asDialog && <Popover.Close asChild>{content}</Popover.Close>}
    </div>
  )
}

export default ConfirmButton
